import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import {
  InsightsContextConfig,
  InsightsEvent,
  InsightsEventProperties,
  InsightsEventsTrackingService,
  getFeatureNameFromAppTitle,
} from '@core/shared/util';
import { InsightsOrganizationInfoService } from '@mp/shared/app-insights/util';

import { AppInsightsService } from './app-insights.service';

@Injectable()
export class AppInsightsFacade implements InsightsEventsTrackingService {
  private readonly appInsightsService: AppInsightsService = inject(AppInsightsService);
  private readonly titleService: Title = inject(Title);
  private readonly insightsOrganizationInfoService: InsightsOrganizationInfoService = inject(
    InsightsOrganizationInfoService,
  );

  trackEvent(
    event: InsightsEvent,
    customProperties: InsightsEventProperties = {},
    contextConfig: InsightsContextConfig = {},
  ): void {
    const eventName =
      contextConfig?.includePageName === false ? event : this.addPageNameToEvent(event, contextConfig?.customPageTitle);

    const organizationName: string | null = this.insightsOrganizationInfoService.organizationName();
    if (organizationName) {
      customProperties = { ...customProperties, organizationName };
    }

    this.appInsightsService.trackEvent(eventName, customProperties);
  }

  private addPageNameToEvent(event: InsightsEvent, customPageTitle?: string): string {
    const currentPageName: string = customPageTitle ?? getFeatureNameFromAppTitle(this.titleService.getTitle());
    return `${currentPageName.replaceAll(' |', '')} | ${event}`;
  }
}
